import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import MenuSection from "../components/MenuSection";
import WhyChooseUs from "../components/WhyChooseUs";
import OrderCTA from "../components/OrderCTA";
import Reservation from "../components/Reservation";
import Hours from "../components/Hours";
import Contact from "../components/Contact";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div data-testid="home-page" className="bg-white text-black min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <MenuSection />
        <WhyChooseUs />
        <OrderCTA />
        <Reservation />
        <Hours />
        <Contact />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
